/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

export const ROUTES = {
  BASE: "/",
  INDEX: "/index.html",
  LOGIN: "/login",
  LOGIN_VIA_CODE: "/login-code",
  LOGOUT: "/logout",
  MAIN_SCREEN: "/",
  HOME: "/hjem",
  WELCOME: "/welcome",
  KIDS: "/boern",
  DANSKFILM: "/danskfilmskat",
  MOVIE_DETAILS_SCREEN: "/film",
  SERIES_DETAILS_SCREEN: "/serie",
  COLLECTION_DETAILS_SCREEN: "/filmsamling",
  PLAYER_SCREEN: "/player",
  PLAYER_CHANNEL_SCREEN: "/player/channel",
  GENRES: "/genre",
  SETTINGS_SUBSCRIPTION: "/settings/subscription",
  SETTINGS_PAYMENT_DETAILS: "/settings/payment-details",
  PAYMENT: "/payment",
  PAYMENT_SUBSCRIPTION: "/payment/choose-subscription",
  PAYMENT_CHANGE_SUBSCRIPTION: "/payment/change-subscription",
  PAYMENT_DETAILS: "/payment/payment-details",
  PAYMENT_VOUCHER: "/payment/payment-voucher",
  PAYMENT_UPDATING: "/payment/updating",
  ASSIGNING_SUBSCRIPTION_SCREEN: "/assigning-subscription",
  SIGN_UP_PAYMENT: "/signup/payment",
  SIGN_UP_RECEIPT: "/signup/receipt",
  NOT_AVAILABLE: "/not-available",

  PLAYLIST_SCREEN: "/playlist",
  SEARCH_SCREEN: "/soeg",
  SEARCH_SMART_SCREEN: "/search",
  SETTINGS_SCREEN: "/settings",
  SETTINGS_PERSONAL_DETAILS_SCREEN: "/settings/personal-details",
  SETTINGS_ABOUT_SCREEN: "/settings/about",
  SETTINGS_MY_CONSENTS_SCREEN: "/settings/my-consents",
  SETTINGS_REGULATIONS_SCREEN: "/settings/regulations",
  SETTINGS_PRIVACY_POLICY_SCREEN: "/settings/privacy-policy",
  SETTINGS_ADD_SUBRPOFILE: "/settings/add-subprofile",
  SETTINGS_EDIT_SUBRPOFILE: "/settings/edit-subprofile",
  SETTINGS_CHANGE_PASSWORD: "/settings/change-password",
  PRIVACY_POLICY_SCREEN: "/privacy-policy",
  SETTINGS_SUBPROFILE_SCREEN: "/settings/profiles",
  SELECT_PROFILE_SCREEN: "/select-profile",
  SETTINGS_MY_ORDERS: "/settings/my-orders",
  MYLIST_SCREEN: "/my-list",
  CATEGORY_SCREEN: "/category",
  LINK_SCREEN: "/link",
  UPDATED_TERMS_SCREEN: "/updated-terms",
  PAGE_NOT_FOUND: "/404",
  SUBPROFILES_FORGOT_PIN: "/forgot-pin",
  TV_CODE_LOGIN: "/tv",
  PERSON_DETAILS_SCREEN: "/person",
  RECOMMENDATIONS_SCREEN: "/recommendations",
  MY_ACCOUNT: "/myaccount",
  API_UPDATE_TOKENS: "/api/token/update-token",
  API_SIGN_IN: "/api/sign-in/sign-in",
  API_LOGOUT: "/api/logout/logout",
  API_SET_CHILD_COOKIE: "/api/profile/setChildCookie",
  API_SYNC_USER: "/api/sync/user",
  API_SYNC_DATA: "/api/sync/data",
  API_SIGN_IN_VIA_TOKEN: "/api/sign-in/sign-token",
  API_CHANGE_PASSWORD: "/api/change-password/change-password",
} as const;
